import { render, staticRenderFns } from "./Preferencias.vue?vue&type=template&id=22185400&scoped=true"
import script from "./Preferencias.vue?vue&type=script&lang=js"
export * from "./Preferencias.vue?vue&type=script&lang=js"
import style0 from "./Preferencias.vue?vue&type=style&index=0&id=22185400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22185400",
  null
  
)

export default component.exports